<template>
  <div class="redact">
    <div class="redact-top">
      <span>
        <img src="../../assets//img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span v-if="fromUrl">
        <router-link :to="{ name: 'product' }">产品管理</router-link>&nbsp;/&nbsp;
      </span>
      <span v-if="!fromUrl">
        <router-link :to="{ name: 'task' }">任务管理</router-link>&nbsp;/&nbsp;
      </span>
      <span>
        任务编辑
      </span>
      <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback">返回</el-button>
    </div>
    <div class="redact-content">
      <el-form label-width="80px" :model="formdata" class="form-content" :rules="redactRules" v-loading="loading">
        <el-form-item label="关联产品">
          <el-select v-model="formdata.productid" placeholder="请选择" class="redact-item-width" @change="selectProduct">
            <el-option v-for="item in products" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="formdata.name" placeholder="请输入名称" class="redact-item-width"></el-input>
        </el-form-item>
        <template v-if="formdata.productid > 0">
          <el-form-item label="相册" class="photo-item">
            <div class="material">
              <el-checkbox-group v-model="formdata.file_ids" class="material-group">
                <div class="material-item" v-for="item in files" :key="item.fileId">
                  <div class="material-checked">
                    <el-checkbox :label="item.fileId" :key="item.fileId"></el-checkbox>
                  </div>
                  <div class="material-item-video" v-if="item.type == 'video'">
                    <video :src="item.url" controls controlslist="nodownload nofullscreen noremoteplayback noplaybackrate"
                      disablePictureInPicture style="object-fit: fill">
                    </video>
                  </div>
                  <div class="material-item-img" v-else-if="item.type == 'image'">
                    <img :src="resize(item.url)" alt="">
                    <div class="material-item-img-icon">
                      <img src="../../assets/img/img-icon.png" alt="">
                    </div>
                  </div>
                  <span class="material-item-title">{{ item.name }}</span>
                </div>
              </el-checkbox-group>
            </div>
            <el-button type="text" @click="checkall">
              全选
            </el-button>
            <el-button type="text" class="el-icon-setting"
              @click="urlto('/material/photo', { pid: formdata.productid, name: formdata.productname })"></el-button>
          </el-form-item>
          <!-- 字幕 -->
          <el-form-item label="字幕" class="subtitle-box">
            <el-checkbox-group v-model="formdata.subtitle_ids">
              <p v-for="item in subtitles">
                <el-checkbox-button :label="item.value" :key="item.value" class="title-checkbox">{{
                  item.label }}</el-checkbox-button>
              </p>
            </el-checkbox-group>
            <el-button type="text" class="el-icon-setting"
              @click="urlto('/material/subtitle', { pid: formdata.productid, name: formdata.productname })"></el-button>
          </el-form-item>
          <el-form-item label="背景图片">
            <el-upload class="photo-Particular-upload" action="/api/file/upload" :headers="headers"
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
              :on-error="uploadError" accept=".jpg,.png">
              <el-button class="photo-Particular-upload-btn" :loading="uploading" icon="el-icon-upload">
                上传背景图片
              </el-button>
            </el-upload>
            <img class="bgimg" v-if="formdata.bgimg" :src="formdata.bgimg" />
          </el-form-item>
          <!-- BGM -->
          <el-form-item label="背景音乐">
            <div class="bgmusic-box" v-if="formdata.music_ids.length == 0">
              <el-button size="small" class="bgmusic-box-btn" @click="bgmusicHnadle">选择背景音乐</el-button>
              <el-button type="text" class="el-icon-setting"
                @click="urlto('/material/bgmusic', { referer: 'task' })"></el-button>
            </div>
            <div class="subtitle-music" v-else>
              <div class="subtitle-music-img">
                <img src="../../assets//img/bgmusic-icon.png" alt="">
              </div>
              <div>
                <span class="subtitle-music-name">{{ formdata.bgmusic_names }}</span>
              </div>
              <el-button type="text" class="subtitle-music-reselection" @click="bgmusicHnadle">重新选择</el-button>
              <el-button type="text" class="el-icon-setting"
                @click="urlto('/material/bgmusic', { referer: 'task' })"></el-button>
            </div>

          </el-form-item>
          <!-- Audio -->
          <el-form-item label="字幕配音">
            <div class="bgmusic-box" v-if="formdata.audios.length == 0">
              <el-button size="small" class="bgmusic-box-btn" @click="subtitleMusicHandle">选择字幕配音</el-button>
              <el-button type="text" class="el-icon-setting"
                @click="urlto('/material/dubbing', { referer: 'task' })"></el-button>
            </div>
            <div class="subtitle-music" v-else>
              <div class="subtitle-music-img">
                <img src="../../assets//img/bgmusic-icon.png" alt="">
              </div>
              <div>
                <span class="subtitle-music-name">{{ formdata.audio_names }}</span>
              </div>
              <el-button type="text" class="subtitle-music-reselection" @click="subtitleMusicHandle">重新选择</el-button>
              <el-button type="text" class="el-icon-setting"
                @click="urlto('/material/dubbing', { referer: 'task' })"></el-button>
            </div>
          </el-form-item>
          <el-form-item label="分辨率" prop="fbl">
            <!-- <el-radio v-model="formdata.fbl" label="16:9">16:9</el-radio> -->
            <el-radio v-model="formdata.fbl" label="9:16">9:16</el-radio>
            <!-- <el-radio v-model="formdata.fbl" label="9:16半屏">9:16半屏</el-radio> -->
          </el-form-item>
          <el-form-item label="生成数量" prop="plan_num">
            <el-input v-model="formdata.plan_num" type="number" style="width:80px;"></el-input>
          </el-form-item>
          <el-form-item label="标题组" class="headline">
            <div class="titlebox">

              <el-input v-model="titleadd[0]" placeholder="输入主标题" size="small" style="margin-left:28px;"></el-input>
              <el-input v-model="titleadd[1]" placeholder="输入副标题" size="small"></el-input>
              <el-button type="text" icon="el-icon-plus" @click="AddTitle">添加</el-button>
              <el-button type="text" icon="el-icon-cpu" @click="openCreation">AI推荐</el-button>
            </div>
            <div class="titlebox" v-for="(item, i) in formdata.titles">
              <span v-if="i < 9"> {{ i + 1 }}. &nbsp; &nbsp;</span>
              <span v-else> {{ i + 1 }}. &nbsp;</span>

              <el-input v-model="item[0]" placeholder="主标题" size="small"></el-input>
              <el-input v-model="item[1]" placeholder="副标题" size="small"></el-input>
              <el-button type="text" icon="el-icon-delete" @click="DelTitle(i)">删除</el-button>
            </div>
          </el-form-item>
        </template>
        <el-form-item class="form-bottom-box-btn">
          <div class="form-bottom-box">
            <el-button class="form-bottom-cancel-btn" @click="urlback()" v-if="formdata.taskid > 0">返回</el-button>
            <el-button class="form-bottom-notarize-btn" @click="submit" v-if="formdata.taskid == 0">添加</el-button>
            <el-button class="form-bottom-notarize-btn" @click="submit" v-if="formdata.state != 'Cancel'">修改</el-button>
          </div>
        </el-form-item>
      </el-form>

    </div>
    <!-- 背景音乐弹框 -->
    <div>
      <el-dialog title="选择背景音乐" class="subtitle-music-dialog" :visible.sync="bgmusicDialog" width="450px"
        :close-on-click-modal="false" @close="StopAudio">
        <audio ref="audio" controls id="audio" style="position: fixed;bottom: 10px;left: 10px;" hidden></audio>
        <div>
          <el-table :data="musics" width="100%" height="500" :visible.sync="bgmusicDialog"
            :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: '400' }"
            @selection-change="select_music" ref="music_table">
            <el-table-column prop="file_name" label="名称">
            </el-table-column>
            <el-table-column label="试听">
              <template slot-scope="scope">
                <img src="../../assets//img/play-icon.png" alt="" @click="play(scope.row.url)" style="cursor: pointer;">
              </template>
            </el-table-column>
            <el-table-column type="selection" width="55"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="bgmusicDialog = false" class="dialog-footer-btn dialog-footer-confirm">确
            定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 字幕配音弹框 -->
    <div>
      <el-dialog title="选择字幕配音" class="subtitle-music-dialog" :visible.sync="subtitleMusicDialog" width="450px"
        :close-on-click-modal="false" @close="StopAudio">
        <audio ref="audio" controls id="audio" style="position: fixed;bottom: 10px;left: 10px;" hidden></audio>
        <div>
          <el-table :data="audios" width="100%" height="500" :visible.sync="subtitleMusicDialog"
            :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: '400' }"
            @selection-change="select_audio" ref="audio_table">
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column prop="name" label="名称">
            </el-table-column>
            <el-table-column label="试听">
              <template slot-scope="scope">
                <img src="../../assets//img/play-icon.png" alt="" @click="play(scope.row.url)" style="cursor: pointer;">
              </template>
            </el-table-column>
            <el-table-column type="selection" width="55"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="subtitleMusicDialog = false" class="dialog-footer-btn dialog-footer-confirm">确
            定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 推荐标题 -->
    <div>
      <el-dialog title="标题推荐" class="creation-dialog" width="730px" :visible.sync="creationDialog"
        :close-on-click-modal="false">
        <el-table ref="creation" style="width: 100%" :data="creationsData" @selection-change="handleSelectionChange"
          :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: 'bold' }"
          v-loading="creation_loading" height="528">

          <el-table-column prop="title" label="主标题">
          </el-table-column>
          <el-table-column prop="sub_title" label="副标题">
          </el-table-column>
          <el-table-column type="selection" align="center">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="refreshCreation" class="dialog-footer-btn dialog-footer-cancel"
            icon="el-icon-refresh">换一批</el-button>
          <el-button @click="creationDialog = false" class="dialog-footer-btn dialog-footer-cancel">取 消</el-button>
          <el-button type="primary" @click="confirmCreation" class="dialog-footer-btn dialog-footer-confirm">确
            定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { creation_title } from '../../assets/js/creation'
import { resize } from '../../assets/js/common';
export default {
  name: 'redactPage',
  data() {
    return {
      // 背景音乐
      bgmusicDialog: false,
      // 字幕配音弹框
      subtitleMusicDialog: false,
      // 表单验证
      redactRules: {},
      // 判断跳转路径
      fromUrl: '',
      formdata: {
        taskid: 0,
        name: '',
        productid: 0,
        productname: '',
        file_ids: [],
        subtitle_ids: [],

        music_ids: [],
        bgmusic_names: '',

        audios: [],
        audio_names: '',

        fbl: '9:16',
        plan_num: 1,

        titles: [],
        state: '',

        bgimg: '',
      },
      products: [],
      albums: [],
      files: [],
      subtitles: [],
      musics: [],
      audios: [],
      titleadd: ['', ''],

      creation_ismain: true,
      creationsData: null,
      creations_selects: [],
      creationDialog: false,
      creation_loading: false,

      loading: false,

      headers: {},
      uploading: false,
    }
  },
  created() {
    this.headers = { Authorization: 'Bearer ' + localStorage.getItem('ai-token') };
    //Product
    this.$get('/product/options?type=0', { init: '请选择一个产品' }).then(res => {
      this.products = res.data;
      // 路由判断
      var query = this.$route.query;
      if (Number(query.pid) > 0) {
        localStorage.removeItem('ai-task');
        this.formdata.productid = Number(query.pid);
        this.selectProduct(this.formdata.productid);
        return;
      }
      if (query.taskid) {
        localStorage.removeItem('ai-task');
        this.get(query.taskid);
        return;
      }
      // 缓存判断
      let cache = JSON.parse(localStorage.getItem('ai-task'));
      if (cache) {
        this.formdata = cache;
        this.selectProduct(this.formdata.productid);
      }
    });
    //BGM
    this.$get('/music/list?size=0').then(res => {
      this.musics = res.data.data;
    });
    //audios
    this.$get('/audio/list').then(res => {
      this.audios = res.data;
    })
  },
  methods: {
    resize(url) {
      return resize(url)
    },
    // 背景音乐
    bgmusicHnadle() {
      this.bgmusicDialog = true;
      var rows = this.$linq.from(this.musics).where(w => this.formdata.music_ids.indexOf(w.file_id) >= 0).toArray();
      this.$nextTick(() => {
        if (rows.length > 0) {
          rows.forEach(row => {
            this.$refs.music_table.toggleRowSelection(row, true);
          });
        }
      })
    },
    select_music(val) {
      this.formdata.music_ids = this.$linq.from(val).select(s => s.file_id).toArray()
      let p = this.$linq.from(val).select(s => s.file_name).toArray();
      if (p.length == 0) {
        this.formdata.bgmusic_names = ''
      } else if (p.length == 1) {
        this.formdata.bgmusic_names = p[0];
      } else {
        this.formdata.bgmusic_names = p[0] + '...等' + p.length + '个音频';
      }
    },
    // 配音
    subtitleMusicHandle() {
      this.subtitleMusicDialog = true;
      var rows = this.$linq.from(this.audios).where(w => this.formdata.audios.indexOf(w.audioCode) >= 0).toArray();
      console.log(this.formdata.audios)
      this.$nextTick(() => {
        if (rows.length > 0) {
          rows.forEach(row => {
            this.$refs.audio_table.toggleRowSelection(row, true);
          });
        }
      });
    },
    select_audio(val) {
      this.formdata.audios = this.$linq.from(val).select(s => s.audioCode).toArray();
      let p = this.$linq.from(val).select(s => s.name).toArray();
      if (p.length == 0) {
        this.formdata.audio_names = ''
      } else if (p.length == 1) {
        this.formdata.audio_names = p[0];
      } else {
        this.formdata.audio_names = p[0] + '...等' + p.length + '个配音';
      }
    },
    urlto(router, params) {
      localStorage.setItem('ai-task', JSON.stringify(this.formdata));
      let url = router + "?" + new URLSearchParams(params).toString();
      this.$router.push(url);
    },
    urlback() {
      this.$router.go(-1);
    },
    // 选择产品
    selectProduct(val) {
      if (val == 0) { this.formdata.name = ''; return; }
      this.formdata.productname = this.$linq.from(this.products).firstOrDefault(x => x.value == val).label;
      this.formdata.name = this.formdata.productname + this.$moment().format('MMDDHHmm');
      //文件
      this.$get('/option/filesbypid', { productid: this.formdata.productid }).then(res => {
        this.files = res.data;
      });
      //字幕
      this.$get('/option/subtitle', { productid: this.formdata.productid }).then(res => {
        this.subtitles = res.data;
      });
    },
    //播放器
    play(url) {
      this.$refs.audio.src = url;
      this.$refs.audio.play();
    },
    StopAudio() {
      this.$refs.audio.pause();
    },
    //提交表单
    submit() {
      let model = {
        id: this.formdata.taskid,
        product_id: this.formdata.productid,
        file_ids: this.formdata.file_ids,
        subtitle_ids: this.formdata.subtitle_ids,
        music_ids: this.formdata.music_ids,
        audios: this.formdata.audios,
        plan_num: this.formdata.plan_num,
        fbl: this.formdata.fbl,
        name: this.formdata.name,
        titles: this.formdata.titles,
        bgimg: this.formdata.bgimg,
      };
      if (model.product_id > 0 == false) {
        this.$message.error('请选择产品'); return;
      }
      else if (model.file_ids.length == 0) {
        this.$message.error('请选择相册'); return;
      }
      else if (model.subtitle_ids.length == 0) {
        this.$message.error('请选择字幕'); return;
      }
      else if (this.formdata.titles.length < 3) {
        this.$message.error('标题组数量至少要三个'); return;
      }

      if (this.formdata.taskid > 0) {
        this.$confirm('修改任务将会取消队列中的视频生成, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          this.update(model);
        })
      } else {
        this.update(model);
      }
    },
    update(model) {
      this.loading = true;
      this.$post('/task/update', model).then(res => {
        if (res.code == 200) {
          let msg = this.formdata.taskid == 0 ? "添加完成" : "修改完成";
          this.$message.success(msg);
          localStorage.removeItem("ai-task");
          // this.urlback();
          this.$router.push("/task/list")
        } else {
          console.log(res);
          this.$message.error('操作失败：' + res.msg);
        }
        this.loading = false;
      }).catch(c => {
        this.$message.error('操作失败');
        this.loading = false;
      })
    },
    get(taskid) {
      this.loading = true;
      this.$get('/task/detail', { task_id: taskid }).then(res => {
        if (res.code == 200) {
          var model = res.data;
          this.formdata = {
            taskid: model.task_id,
            name: model.name,
            productid: model.product.product_id,
            productname: model.product.product_name,
            file_ids: model.file_ids,
            subtitle_ids: model.subtitle_ids,

            music_ids: model.music_ids,
            bgmusic_names: model.bgmusic_names,

            audios: model.audios,
            audio_names: model.audio_names,

            titles: model.titles,
            fbl: model.fbl,
            plan_num: model.plan_num,
            state: model.state,
            bgimg: model.bgimg,
          };
          this.selectProduct(this.formdata.productid);

        } else {
          this.$message.error(res.msg);
          this.urlback();
        }
      }).finally(res => {
        this.loading = false;
      })
    },
    // ai标题
    AddTitle() {
      if (this.titleadd[0] == "" || this.titleadd[1] == "") {
        this.$message.error("请先输入标题组");
        return;
      }
      this.formdata.titles.push(this.titleadd);
      this.titleadd = ["", ""];
    },
    DelTitle(i) {
      this.formdata.titles.splice(i, 1);
    },
    openCreation() {
      this.creationDialog = true;
      if (this.creationsData != null) return;
      this.creation_loading = true;
      this.$get('/ai/creation_title', { q: this.formdata.productname }).then(res => {
        if (res.code == 200) {
          this.creationsData = res.data;
          this.$nextTick(() => {
            this.creationsData.forEach(row => {
              this.$refs.creation.toggleRowSelection(row, true);
            });
          });
        }
      }).finally(res => {
        this.creation_loading = false;
      });
    },
    refreshCreation() {
      this.creationsData = null;
      this.openCreation();
    },
    handleSelectionChange(v) {
      this.creations_selects = [];
      for (let i in v) {
        this.creations_selects.push(v[i]);
      }
    },
    confirmCreation() {
      this.creationDialog = false;
      for (let i in this.creations_selects) {
        let title = this.creations_selects[i].title;
        let subtitle = this.creations_selects[i].sub_title;
        this.formdata.titles.push([title, subtitle]);
      }
    },
    // 全选相册
    checkall() {
      let p = [];
      for (let i in this.files) {
        p.push(this.files[i].fileId);
      }
      this.formdata.file_ids = p;
    },
    //上传背景图
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.formdata.bgimg = res.data.url;
      }
      this.uploading = false;
    },
    beforeAvatarUpload() {
      this.uploading = true;
    },
    uploadError() {
      this.$message.error("上传失败");
      this.uploading = false;
    },

  },

  beforeRouteEnter(to, from, next) {
    if (from.name == 'task') {
      sessionStorage.setItem('name', '任务管理')
    } else if (from.name == 'productMain') {
      sessionStorage.setItem('name', '产品管理')
    }
    next()

  },
  // 
  mounted() {

  },
}

</script>

<style scoped>
.redact-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.redact-top {
  color: #606266;
  font-size: 14px;
}

.redact-top .home-icon-img {
  margin-right: 4px;
}

.redact-top a {
  color: #606266;
}

.redact-top a:hover {
  color: #006cff;
}

.form-content {
  margin-right: 40px;
}

.redact {
  height: calc(100% - 60px);
}

.redact-content {
  background-color: #fff;
  box-sizing: border-box;
  height: 100%;
  padding: 27px 40px;
  position: relative;
}

.redact-refresh {
  position: absolute;
  right: 16px;
  top: 26px;
  display: flex;
  align-items: center;
  color: #006cff;
  font-size: 14px;
  cursor: pointer;
}

.redact-refresh>>>span {
  display: flex;
  align-items: center;
  color: #006cff;
}

.redact-refresh img {
  margin-right: 4px;
}

/*  */
.title-checkbox {
  margin-right: 10px;
}

.title-checkbox>>>.el-checkbox-button__inner {
  border: 1px solid #d9dde5;
  border-radius: 3px;
  box-shadow: none;
  padding: 12px 20px;
  font-size: 14px;
  color: #595959;
  text-align: left;
}

.title-checkbox>>>.is-checked {
  border: 1px solid #d9dde5;
}

.el-checkbox-button,
.el-checkbox-button__inner {
  display: inline-block;
  position: relative;
}

.redact-content>>>.el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #006CFF !important;
  border-color: #006CFF;
  background-color: #fff;
  box-shadow: none;
}

.bgmusic-box {
  display: flex;
  align-items: center;
}

.bgmusic-box-hint {
  font-size: 14px;
  color: #595959;
  margin-left: 14px;
}

.bgmusic-box-hint i {
  margin-left: 16px;
}

.bgmusic-box-btn {
  width: 120px;
  height: 36px;
  background-color: #e6f0ff;
  border: 1px solid #99c4ff;
  border-radius: 3px;
  color: #006CFF;
  font-size: 14px;
}

.bgmusic-img-box {
  display: flex;
  align-items: center;
}

.bgmusic-img-box-img {
  width: 44px;
  height: 44px;
  background-color: #573dff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.bgmusic-dialog-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-right: 15px;
}

.bgmusic-dialog-top-right {
  position: relative;
  display: flex;
  align-items: center;
  width: 172px;
  height: 36px;
}

.bgmusic-dialog-top-right>>>.el-input input {
  padding-right: 40px;
}

.bgmusic-dialog-search-btn {
  position: absolute;
  right: 14px;
}

.bgmusic-upload-btn {
  width: 110px;
  height: 36px;
  border: 1px solid #006CFF;
  border-radius: 3px;
  padding: 0;
  color: #006cff;
  font-size: 14px;
}

.bgmusic-dialog>>>.el-dialog__header {
  padding: 16px 18px;
  border-bottom: 1px solid #eee;
}

.bgmusic-dialog>>>.el-dialog__body {
  padding-top: 14px;
  padding-bottom: 18px;
}

.bgmusic-dialog>>>.el-dialog__footer {
  border-top: 1px solid #eee;
  padding-top: 18px;
}

.bgmusic-dialog>>>.dialog-footer-btn {
  height: 36px;
  width: 74px;
  padding: 0;
  font-size: 14px;
}

.bgmusic-dialog .dialog-footer-cancel {
  color: #606266;
}

.bgmusic-dialog .dialog-footer-confirm {
  background-color: #006cff;
  color: #fff;
}

.bgmusic-dialog-radio>>>.el-radio__label {
  display: none;
}

.bgmusic-dialog-radio>>>.el-radio__input.is-checked .el-radio__inner {
  background-color: #fff;
  border: 1px solid #006cff;
}

.bgmusic-dialog-radio>>>.el-radio__input.is-checked .el-radio__inner::after {
  background-color: #006cff;
}

.bgmusic-dialog>>>.el-dialog__title {
  font-size: 15px;
  color: #333;
}

.subtitle-music {
  max-width: 764px;
  background-color: #f5f5f5;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 0px 14px;
  height: 36px;
  display: flex;
  align-items: center;
}

.subtitle-music-img {
  width: 20px;
  height: 20px;
  background-color: #573dff;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.subtitle-music-img img {
  width: 50%;
}

.subtitle-music-name {
  font-size: 14px;
  color: #696969;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.subtitle-music-reselection {
  color: #006cff;
  font-size: 14px;
  margin-left: 20px;
}

.subtitle-music-dialog>>>.el-table__cell {
  padding: 14px 0;
}

.subtitle-music-dialog>>>.el-dialog__title {
  font-size: 15px;
  color: #333;
}

.subtitle-music-dialog>>>.el-dialog__header {
  padding: 16px 18px;
  border-bottom: 1px solid #eee;
}

.subtitle-music-dialog>>>.el-dialog__body {
  padding-top: 14px;
  padding-bottom: 18px;
}

.subtitle-music-dialog>>>.el-dialog__footer {
  border-top: 1px solid #eee;
  padding-top: 18px;
}

.subtitle-music-dialog>>>.dialog-footer-btn {
  height: 36px;
  width: 74px;
  padding: 0;
  font-size: 14px;
}

.subtitle-music-dialog .dialog-footer-cancel {
  color: #606266;
}

.subtitle-music-dialog .dialog-footer-confirm {
  background-color: #006cff;
  color: #fff;
}

.redact-item-width {
  max-width: 764px;
  width: 100%;
}

.redact-item-width>>>input {
  height: 36px;
}

.video-configuration {
  font-size: 14px;
  color: #006cff;
}

.bottom-border {
  margin: 0;
  box-sizing: border-box;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebf0f6;
}

.form-bottom-box-btn>>>.el-form-item__content {
  margin: 0 !important;
}

.form-bottom-box {
  box-sizing: border-box;
  padding-top: 16px;
  padding-left: 16px;
}

.form-bottom-box .form-bottom-cancel-btn {
  width: 74px;
  height: 40px;
  background-color: rgba(235, 240, 246, 0);
  border: 1px solid #d9dde5;
  border-radius: 3px;
  font-size: 14px;
  color: #606266;
  opacity: 1;
  transition: all 0.2s linear;
}

.form-bottom-box .form-bottom-cancel-btn:hover {
  opacity: 0.9;
}

.form-bottom-box .form-bottom-notarize-btn {
  width: 74px;
  height: 40px;
  background-color: #006cff;
  border-radius: 3px;
  font-size: 14px;
  border: none;
  color: #fff;
  opacity: 1;
  transition: all 0.2s linear;
}

.form-bottom-box .form-bottom-notarize-btn:hover {
  opacity: 0.9;
}

.redact-content .material {
  max-width: 630px;
  border: 1px solid #d9dde5;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 18px 14px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-height: 485px;
  overflow-y: auto;
}

.material-item {
  width: 23.5%;
  max-width: 170px;
  box-sizing: border-box;
  margin-bottom: 10px;
  position: relative;
  margin-right: 1.3%;
  border: 5px;
  padding: 10px;
}

.material-item:nth-child(4) {
  margin-right: 0;
}

.material-item-video {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.material-item-video video {
  max-width: 100%;
  height: 85px;
  border-radius: 5px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

.material-item-img {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.material-item-img>img {
  max-width: 100%;
  height: 85px;
  border-radius: 5px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

.material-item-title {
  line-height: 1;
  margin-top: 6px;
  display: block;
  width: 100%;
  font-size: 12px;
  color: #333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  padding: 0 8px;
}

.material-item-img-icon {
  position: absolute;
  bottom: 20px;
  left: 14px;
}

video::-webkit-media-controls-timeline {
  display: none;
}

video::-webkit-media-controls-mute-button {
  display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}

video::-webkit-media-controls-volume-slider {
  display: none;
}

.material-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.material-checked {
  position: absolute;
  right: 2px;
  top: -2px;
  width: 18px;
  height: 18px;
}

.material-checked>>>.el-checkbox {
  width: 18px;
  height: 18px;
  margin: 0;
}

.material-checked>>>.el-checkbox .el-checkbox__label {
  display: none;
}

.material-checked>>>.el-checkbox__inner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  /* 修改 */
  border: 2px solid #d9dde5;
}

.material-checked>>>.is-checked .el-checkbox__inner {
  background-color: #006cff;
  border: 2px solid #006cff;
}

.material-checked>>>.el-checkbox__inner::after {
  left: 6px;
  top: 2px;
}

.subtitle-box>>>.el-form-item__content .el-checkbox-group {
  overflow-y: auto;
  max-height: 300px;
  box-sizing: border-box;
  padding-right: 10px;
}

.subtitle-box>>>.el-checkbox-button {
  width: 100%;
  margin-bottom: 8px;
}

.subtitle-box>>>.el-checkbox-button__inner {
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.headline>>>.el-form-item__content {
  max-height: 270px;
  overflow-y: auto;
}

@media screen and (max-width:1024px) {
  .redact-content {
    height: 100%;
    padding: 25px 30px;
    position: relative;
  }

  .material-item {
    width: 139px;
  }

  .nowrap {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.keyword-random-btn {
  width: 100px;
  height: 36px;
  background-color: #006cff !important;
  border-radius: 5px;
  padding: 0;
  color: #fff !important;
  font-size: 14px;
  opacity: 1;
  transition: all 0.2s linear;
}

.keyword-random-btn:hover {
  opacity: 0.9;
}

.subtitle-music-dialog>>>tbody tr td:last-child .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.creation-dialog>>>.el-dialog__body {
  padding: 14px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.creation-dialog .dialog-footer-confirm {
  background-color: #006cff;
  opacity: 1;
  transition: all 0.2s ease;
}

.creation-dialog .dialog-footer-confirm:hover {
  background-color: #006cff;
  opacity: 0.9;
}

.creation-dialog>>>.el-dialog__title {
  font-size: 15px;
  color: #333;
}

.creation-dialog>>>.el-dialog__header {
  padding: 16px 18px;
  border-bottom: 1px solid #eee;
}

.creation-dialog>>>.el-dialog__footer {
  padding-top: 18px;
  border-top: 1px solid #eee;
}

/* .creation-dialog>>>.el-dialog__body {
  height: 485px;
} */

.titlebox .el-input {
  width: 270px;
  margin-right: 20px;
  margin-bottom: 5px;
}

.bgimg {
  height: 160px;
  margin-top: 12px;
}




.photo-item .material {
  width: 100%;
  max-width: 764px;
}

.subtitle-box>>>.el-checkbox-group {
  box-sizing: border-box;
  border: 1px solid #d9dde5;
  padding: 10px;
}

.headline>>>.el-form-item__content {
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #d9dde5;
}
</style>